import React from 'react';
import { UserProfileProvider } from '../contexts/UserProfileProvider';
import { useUserProfile } from '../contexts/useUserProfile';
import { DailyReportsWebSocketProvider } from '../contexts/DailyReportsWebSocketContext';
import { PageSkeleton } from './crm-ui';
import ReceptionLayoutProvider from '../pages/reception/ReceptionLayout';

/**
 * Inner wrapper that accesses UserProfile context to conditionally enable WebSocket
 */
const WithDailyReportsWebSocket: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { showSuper } = useUserProfile();
  
  return (
    <DailyReportsWebSocketProvider enabled={showSuper}>
      {children}
    </DailyReportsWebSocketProvider>
  );
};

/**
 * Wrapper component that provides UserProfile and DailyReports WebSocket context to reception pages
 * Enables real-time daily reports updates via single shared WebSocket connection
 */
export const ReceptionPageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <UserProfileProvider>
      <WithDailyReportsWebSocket>
        <ReceptionLayoutProvider>
          <React.Suspense fallback={<PageSkeleton variant="reception" />}>
            {children}
          </React.Suspense>
        </ReceptionLayoutProvider>
      </WithDailyReportsWebSocket>
    </UserProfileProvider>
  );
};
